import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ExternalSenderLoginDTO } from '../masterdata/models/externalSenderLogin';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';

@Component({
  selector: 'app-exteral-sender-login-template',
  templateUrl: './exteral-sender-login-template.component.html',
  styleUrls: ['./exteral-sender-login-template.component.css']
})
export class ExteralSenderLoginTemplateComponent implements OnInit {

  @Input() masterLists: ExternalSenderLoginDTO[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading:boolean;
  
  labOption: LabMDM[] = [];
  selectedMasterList: ExternalSenderLoginDTO;
  popupTitle: string;
  isNewExternalLogin: boolean;
  currentExternalSenderLogin: ExternalSenderLoginDTO;
  displayMasterListDialog: boolean;
  errorHandler: ErrorHandler = new ErrorHandler;
  senders: any[];
  blocked = false;
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
  }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
    this.isNewExternalLogin = false;
    this.displayMasterListDialog = false;
  }

  onRowSelect(event){
    this.isNewExternalLogin = false;
    this.currentExternalSenderLogin = this.cloneExternalSenderLogin(event.data);
    this.getActiveSenders();
    this.displayMasterListDialog = true;
  }

  cloneExternalSenderLogin(item: any): any{
    let externalSenderLogin = {};
    for(let prop in item){
      externalSenderLogin[prop] = item[prop];
    }
    return externalSenderLogin;
  }

  showDialogToAddMasterList(){
    this.isNewExternalLogin = true;
    this.currentExternalSenderLogin = new ExternalSenderLoginDTO();
    this.getActiveSenders();
    this.displayMasterListDialog = true;
  }

  getActiveSenders() {
    this._masterDataService.getActiveSendersForLab(this.checkSelectedLab.lab._id)
      .subscribe(
        (result) => {
          this.senders = [];
          result.data.forEach(sender => {
            this.senders.push({label: sender.senderName, value: sender.senderName});
          });
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        });
  }
  private handleError(error: any) {
    this.displayMasterListDialog = false;
    this.blocked=false
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }
  saveMasterList(){
    this.currentExternalSenderLogin.lab = this.checkSelectedLab.lab;
    if(this.isNewExternalLogin){
      this.blocked=true
      this._masterDataService.addExternalSenderLogin(this.currentExternalSenderLogin)
        .subscribe(
          (result) => {
            this.displayMasterListDialog = false;
            this.masterLists.push(result.data);
            this.currentExternalSenderLogin = null;
            this._messageService.addSuccessMessage(
              {severity: 'success', summary: 'Success', detail: 'Sender external login configuration added successfully'}
            );
            this.blocked=false
          },
          (error) => {
            this.handleError(error);
          })
    }else{
      let masterLists = [...this.masterLists];
      this.blocked=true
      this._masterDataService.updateExternalSenderLogin(this.currentExternalSenderLogin)
      .subscribe(
        result =>{
          this.displayMasterListDialog = false;
          masterLists[this.masterLists.indexOf(this.selectedMasterList)] = result.data;
          this.masterLists = masterLists;
          this.currentExternalSenderLogin = null;
          this._messageService.addSuccessMessage(
            {severity: 'success', summary: 'Success', detail: 'Sender external login configuration updated successfully'}
          );
          this.blocked=false
        }, error => {
          this.handleError(error);
        }
      )
    }
  }

  isSaveDisabled(){
    if(this.currentExternalSenderLogin == undefined || this.currentExternalSenderLogin == null ||
      this.currentExternalSenderLogin.name==undefined || this.currentExternalSenderLogin.name==null || this.currentExternalSenderLogin.name=='' ||
      this.currentExternalSenderLogin.puid==undefined || this.currentExternalSenderLogin.puid==null || this.currentExternalSenderLogin.puid==''){
      return true;
    }
    return false;
  }

  convertToUpparCase(){
    this.currentExternalSenderLogin.puid = this.currentExternalSenderLogin.puid.trim().toUpperCase();
  }
}
